import { atomWithLazy, loadable, unwrap } from 'jotai/utils';
import { ColumnMeta } from '../../../types';
import { fetchColumns } from '../../queries/MaggieViewQueries';

/**
 * Raw BE column rows across all view types, for the AdminPanel columns list.
 * PortfolioOverview reads per-viewType columns via `columnsMetaState`
 * (ViewStateJ) instead — keys are only unique within a viewType.
 */
export const columnsRawAtom = atomWithLazy<Promise<ColumnMeta[]> | ColumnMeta[]>(() =>
  fetchColumns(undefined)
);

export const columnsRawLoadable = loadable(columnsRawAtom);

// Sync view of the raw columns (empty until the fetch resolves), for readers
// that only need the resolved value and shouldn't suspend.
export const columnsRawUnwrapped = unwrap(columnsRawAtom, (prev) => prev ?? []);
